export const routes = [
  { path: "/", changefreq: "daily", priority: 1.0 },
  { path: "/om-oss", changefreq: "weekly", priority: 0.8 },
  { path: "/kontakta-oss", changefreq: "monthly", priority: 0.7 },
  { path: "tjanster/skadeverkstad-i-goteborg-kungalv", changefreq: "weekly", priority: 0.8 },
  { path: "tjanster/bilverkstad-goteborg-kungalv-kbscenter", changefreq: "monthly", priority: 0.6 },
  { path: "tjanster/rekond-tvatt-kungalv", changefreq: "monthly", priority: 0.6 },
  { path: "tjanster/billackering-bilar-kungalv", changefreq: "monthly", priority: 0.6 },
  { path: "/vanliga-fragor-bilservice", changefreq: "monthly", priority: 0.7 },
];
